<template>
  <div>
    <h3 class="my-5 lg:my-10 2xl:my-15 w-full px-12">
      Curriculum vitae
    </h3>

    <no-cv-found
      v-if="listCvs.length === 0"
      @newCV="(infos) => createNewCv(infos)"
    />

    <div v-if="listCvs.length > 0">
      <list-cv
        :list-cvs="listCvs"
        @modify="
          (cv) => {
            modify(cv);
          }
        "
        @newCV="
          (infos) => {
            createNewCv(infos);
          }
        "
        @remove="
          (cv) => {
            remove(cv);
          }
        "
        @download="
          (cv) => {
            download(cv);
          }
        "
        @dupplicate="
          (cv) => {
            dupplicate(cv);
          }
        "
      />
    </div>
  </div>
</template>

<script>
import axios from './../../api';
import {mapActions, mapGetters, mapMutations} from 'vuex';

import NoCvFound from './NoCvFound';
import ListCv from './ListCv';

import Constants from './../../constants';

export default {
  name:'ListCV',

  components: {
    NoCvFound,
    ListCv,
  },

  data() {
    return {
      emptyDataForm: {
        shaping: {
          name: 'Basic',
          color: 'teal',
        },
        personnal: {
          prenom: { isDisplayed: true, value: '' },
          nom: { isDisplayed: true, value: '' },
          date_naissance: { isDisplayed: true, value: '' },
          telephone: { isDisplayed: true, value: '' },
          email: { isDisplayed: true, value: '' },
          adresse: { isDisplayed: true, value: '' },
          travailleur_handicape: { isDisplayed: true, value: false },
          permis_conduire: { isDisplayed: true, value: [] },
          moyen_transport: { isDisplayed: true, value: [] },
          site_web: { isDisplayed: true, value: '' },
          linkedin: { isDisplayed: true, value: '' },
          profile_image: { isDisplayed: true, value: '' },
        },
        formations: [],
        pros: [],
        atouts: { value: { default: [], perso: [] } },
        competences: [],
        success: {},
        needs: { value: { default: [], perso: [] } },
        langues: [],
        hobbies: [],
      },

      constants: Constants,
    };
  },

  methods: {
    ...mapMutations({
      SET_LOADING: 'app/SET_LOADING',
      SET_FORM: 'curriculumVitae/SET_FORM',
    }),

    ...mapActions({
      loadCvs: 'curriculumVitae/loadCvs',
      removeCV: 'curriculumVitae/removeCV',
      dupplicateCV: 'curriculumVitae/dupplicateCV'
    }),

    async createNewCv(infos) {
      this.SET_LOADING(true);

      let emptyForm = { ...this.emptyDataForm };

      emptyForm.shaping.name =
                infos.type === Constants.CV_TYPES.BASIC ? 'Basic' : 'Dashboard';

      if (infos.type === Constants.CV_TYPES.DASHBOARD) {
        emptyForm.success = {
          value: Object.keys(Constants.cvdatas.success).reduce(
            (acc, v) => {
              return { ...acc, [v]: {} };
            },
            {}
          ),
        };
        emptyForm.success.value.all = false;
      }

      await axios
        .post('api/cv', { ...infos, data: emptyForm })
        .then((response) => {
          this.loadCvs(); //reload CVs list

          let cv = response.data;

          this.$router.push({
            name: 'CvForm',
            params: { user: this.user.id, id: cv.id },
          });

          this.SET_LOADING(false);
        })
        .catch((err) => {
          this.SET_LOADING(false);
          console.log('ERRR:', err);
        });
    },

    modify(cv) {
      this.$router.push({
        name: 'CvForm',
        params: { user: this.user.id, id: cv.id },
      });
    },

    async dupplicate(cv) {
      try {
        await this.dupplicateCV(cv).then((response) => {
          this.loadCvs();
        });
      } catch (error) {
        console.error(error);
      }
    },

    async remove(cv) {
      try {
        await this.removeCV(cv).then((response) => {
          this.loadCvs();
        });
      } catch (error) {
        console.error(error);
      }
    },

    async download(cv) {
      await this.SET_FORM(cv);
      this.$emit('downloadPDF');
    },
  },

  computed: {
    ...mapGetters({
      user:'auth/user',
      loading: 'app/loading',
      listCvs: 'curriculumVitae/listCvs',
      form: 'curriculumVitae/form'
    }),
  },
};
</script>
